import React, {useState} from 'react'
import {Button, Row, Col} from 'react-bootstrap'
import ImageWithText from '../../components/ImageWithText'
import ModalExternalSite from '../../components/ModalExternalSite'
import Section from '../../components/Section'

import DrugIcon from './img/drugs-icon.inline.svg'
import HandsIcon from './img/hands-icon.inline.svg'
import LotionIcon from './img/lotion-icon.inline.svg'
import BottleIcon from './img/bottle-icon.inline.svg'

const ManagingSpots = () => {
  const [displayModal, setDisplayModal] = useState(false)

  const getSvgIcon = (name: string) => {
    if (name === 'drugs') return <DrugIcon className="p-3 p-md-1 p-lg-0" />
    if (name === 'hands') return <HandsIcon className="p-2 p-md-0 p-lg-0" />
    if (name === 'lotion') return <LotionIcon className="p-2 p-md-1 p-lg-0" />
    if (name === 'bottle') return <BottleIcon className="p-2 p-md-1 p-lg-0" />
    return null
  }

  return (
    <Section id="managing-spots" background="purple" className="text-center">
      <h2 className="fs-1 fw-bold mb-4">
        Managing spots
        <br /> and itching
      </h2>
      <p>
        In healthy children, chickenpox will not usually require medical
        treatment. Your pharmacist can advise about medicines that may help
        relieve itching or reduce pain and discomfort. If complications develop,
        your doctor will decide on the appropriate treatment.
      </p>
      <p>
        If you need to book a doctor’s appointment, tell the receptionist that
        your child may have chickenpox. You may need to arrange a special
        appointment time to avoid infecting other patients.
      </p>

      <Row className="mx-2 mx-lg-none my-5 gy-5">
        {data.map(({title, text}) => (
          <Col key={text} lg={3}>
            <ImageWithText
              text={text}
              img={getSvgIcon(title)}
              className="gap-4 px-lg-3"
            />
          </Col>
        ))}
      </Row>

      <p className="fw-semibold mb-5">
        More information about chickenpox can be found via the NHS website*:
      </p>
      <Button
        variant="secondary"
        className="rounded-pill py-3 px-4"
        onClick={() => setDisplayModal(true)}
      >
        Visit the NHS website
      </Button>
      <p className="fw-semibold mt-5">
        *This link will direct you to a thirdparty website. MSD does not endorse
        or recommend any content on this site but signposts this as a reputable
        source for additional information.
      </p>

      <ModalExternalSite
        show={displayModal}
        handleClose={() => setDisplayModal(false)}
        link="https://www.nhs.uk/conditions/chickenpox/"
      />
    </Section>
  )
}

export default ManagingSpots

const data = [
  {
    title: 'drugs',
    text: 'Avoid using ibuprofen for chickenpox unless advised to do so by your doctor.',
  },
  {
    title: 'hands',
    text: 'Don’t scratch! It can cause skin infections or permanent scarring. If your child can’t stop scratching, keep their fingernails short and put gloves or socks on their hands, especially at night.',
  },
  {
    title: 'lotion',
    text: 'Speak to your pharmacist about using cooling creams or gels to relieve itching.',
  },
  {
    title: 'bottle',
    text: 'Drink plenty of fluids to stay hydrated. Try ice lollies if your child isn’t drinking. A diet of soft, cold foods is best if chickenpox sores develop in the mouth.',
  },
]
